import { StormTrackerIcon } from './layerPickerIcons/stormTrackerIcon';
import { RadarIcon } from './layerPickerIcons/radarIcon';
import { AirQualityIcon } from './layerPickerIcons/airQualityIcon';
import { AlertsIcon } from './layerPickerIcons/alertsIcon';
import { DewPointIcon } from './layerPickerIcons/dewPointIcon';
import { FutureRadarIcon } from './layerPickerIcons/futureRadarIcon';
import { HeatIndexIcon } from './layerPickerIcons/heatIndexIcon';
import { HumidityIcon } from './layerPickerIcons/humidityIcon';
import { LightningIcon } from './layerPickerIcons/lightningIcon';
import { LocalPressureIcon } from './layerPickerIcons/localPressureIcon';
import { LocalTemperatureIcon } from './layerPickerIcons/localTemperatureIcon';
import { PollenIcon } from './layerPickerIcons/pollenIcon';
import { PrecipitationIcon } from './layerPickerIcons/precipitationIcon';
import { PressureIcon } from './layerPickerIcons/pressureIcon';
import { SevereStormRiskIcon } from './layerPickerIcons/severeStormRiskIcon';
import { TemperatureIcon } from './layerPickerIcons/temperatureIcon';
import { UsIrSatelliteIcon } from './layerPickerIcons/usIrSatIcon';
import { UsVisibleSatelliteIcon } from './layerPickerIcons/usVisSatIcon';
import { WindChillIcon } from './layerPickerIcons/windChillIcon';
import { WindSpeedIcon } from './layerPickerIcons/windSpeedIcon';
import { WorldWideSatelliteIcon } from './layerPickerIcons/worldWideSatelliteIcon';

export interface LayerPickerIconProps {
    backgroundFillColor: string;
    symbolFillColor?: string;
    width?: number;
    height?: number;
}

export interface LegacyIconProps {
    width?: number;
    height?: number;
    color?: string;
}

export const IconHelper = {
    'airquality': AirQualityIcon,
    'alerts': AlertsIcon,
    'dew-point': DewPointIcon,
    'future-radar': FutureRadarIcon,
    'heat-index': HeatIndexIcon,
    'humidity': HumidityIcon,
    'lightning': LightningIcon,
    'local-pressure': LocalPressureIcon,
    'local-temperature': LocalTemperatureIcon,
    'pollen': PollenIcon,
    'precipitation': PrecipitationIcon,
    'pressure': PressureIcon,
    'radar': RadarIcon,
    'severe-storm-risk': SevereStormRiskIcon,
    'storm-tracker': StormTrackerIcon,
    'temperature': TemperatureIcon,
    'us-ir-sat': UsIrSatelliteIcon,
    'us-vis-sat': UsVisibleSatelliteIcon,
    'wind-chill': WindChillIcon,
    'wind-speed': WindSpeedIcon,
    'worldwide-satellite': WorldWideSatelliteIcon
};

export const unselectedBackgroundFillColor = '#82BC00';
export const selectedBackgroundFillColor = '#0083C6';